import type WorkTag from '@sysarb/sysarb-api/models/entities/WorkTag';
import { TagState } from '@sysarb/sysarb-api/models/entities/WorkTag';
import type { WorkTag as PEAWorkTag } from '@sysarb/sysarb-types-v2/services/v1/pea';
import { i18n } from '@/i18n';
import { useLabs } from '@/views/jobArchitecture/composables/useLabs';

type ReturnType = {
    getTag: (workTag: WorkTag | PEAWorkTag | undefined) => string;
    getTagState: (tagState: TagState) => string;
    getHistoricalTagState: (tagState: TagState) => string;
};

export function useWorkTagsHelper(): ReturnType {
    const { activeFlags } = useLabs();
    /**
     * Gets the correct translation for the tag
     * */
    function getTag(workTag: WorkTag | PEAWorkTag | undefined): string {
        if (workTag != null) {
            switch (workTag.tagEn) {
                case 'Historical salary':
                    if (activeFlags.value.includes('AnalyzeV2')) return i18n.global.t('components.analyzeEmploymentSidebar.analyze.previousEmployment');
                    return i18n.global.t('component.payEquityAudit.workTags.historicalSalary');
                case 'Heterogeneous group':
                    return i18n.global.t('component.payEquityAudit.workTags.heterogenousGroup');
                case 'Performance':
                    return i18n.global.t('component.payEquityAudit.workTags.performance');
                case 'Market salary when recruiting':
                    return i18n.global.t('component.payEquityAudit.workTags.marketSalaryWhenRecruiting');
                case 'Competing labor market':
                    return i18n.global.t('component.payEquityAudit.workTags.competingLaborMarket');
                case 'Experience':
                    return i18n.global.t('component.payEquityAudit.workTags.experience');
                case 'Responsibility':
                    return i18n.global.t('component.payEquityAudit.workTags.responsibility');
                case 'Competence':
                    return i18n.global.t('component.payEquityAudit.workTags.competence');
                default:
                    return '';
            }
        }

        // Return empty string if workTag dont exist (this should never happen)
        return '';
    }

    function getTagState(tagState: TagState): string {
        switch (tagState) {
            case TagState.negative:
                return i18n.global.t('components.workTagsHelper.negative');
            case TagState.positive:
                return i18n.global.t('components.workTagsHelper.positive');
            case TagState.neutral:
                return i18n.global.t('components.workTagsHelper.neutral');
            default:
                return '';
        }
    }

    function getHistoricalTagState(tagState: TagState): string {
        switch (tagState) {
            case TagState.negative:
                return i18n.global.t('components.workTagsHelper.lower');
            case TagState.positive:
                return i18n.global.t('components.workTagsHelper.higher');
            default:
                return '';
        }
    }

    return {
        getTag,
        getTagState,
        getHistoricalTagState
    };
}
